export default {
  methods: {
    async getDocs(category, searchQuery = '', page = 1, limit = 5) {
      const docs = await this.$directus.items('Docs').readMany({ filter: { [category]: true, status: 'published' }, page: page, limit: this.perPage, meta: 'total_count' });
      this.setTot(docs)
      this.setDocs(docs)
    }
  }
};
